<div class="crm-page">
  <div class="crm-container">
    <!-- TOP BAR -->
    <header class="crm-top">
      <div class="brand">
        <div class="hero-logo">
          <img src="../../assets/images/Logo.svg" alt="Nishwik Logo" class="img-fluid" />
        </div>
        <span class="module-chip"><i class="fas fa-handshake"></i> CRM</span>
      </div>
      <div class="top-link">
        New to Nishwik CRM?
        <a routerLink="/signup">Create account</a>
      </div>
    </header>

    <main class="crm-main">
      <!-- SHOWCASE -->
      <section class="showcase">
        <h1 class="headline">Every lead, every deal, one clear pipeline.</h1>
        <p class="lede">
          Capture leads, follow up on time and see which deals are close to
          winning. Your whole sales team works from the same live view.
        </p>

        <!-- Pipeline board: illustrative sample data -->
        <div class="board" aria-label="Sample sales pipeline">
          <div class="board-head">
            <span class="board-title">Sales pipeline</span>
            <span class="board-total">Open value <strong>₹ 48.2 L</strong></span>
          </div>

          <div class="stages">
            <div class="stage">
              <div class="stage-name">New lead <span class="stage-count">12</span></div>
              <div class="slot"></div>
              <div class="deal"><b>Kiran Traders</b><span>₹ 1.8 L</span></div>
              <div class="deal"><b>Bright Dental Care</b><span>₹ 0.9 L</span></div>
            </div>
            <div class="stage">
              <div class="stage-name">Qualified <span class="stage-count">8</span></div>
              <div class="slot"></div>
              <div class="deal"><b>Shree Logistics</b><span>₹ 6.4 L</span></div>
              <div class="deal"><b>Mehta &amp; Sons</b><span>₹ 2.2 L</span></div>
            </div>
            <div class="stage">
              <div class="stage-name">Proposal <span class="stage-count">5</span></div>
              <div class="slot"></div>
              <div class="deal"><b>Urban Fitness</b><span>₹ 3.5 L</span></div>
              <div class="deal"><b>Greenleaf School</b><span>₹ 7.1 L</span></div>
            </div>
            <div class="stage">
              <div class="stage-name">Won <span class="stage-count">9</span></div>
              <div class="slot"></div>
              <div class="deal is-won"><b>Patel Hospital</b><span>Closed · ₹ 9.0 L</span></div>
              <div class="deal is-won"><b>Zenith Realty</b><span>Closed · ₹ 4.6 L</span></div>
            </div>
          </div>

          <div class="lane" aria-hidden="true">
            <div class="traveller">
              <b>Asha Textiles</b>
              <span>Moves to Won · ₹ 4.2 L</span>
            </div>
          </div>
        </div>

        <ul class="capabilities">
          <li>
            <span class="cap-icon"><i class="fas fa-bell"></i></span>
            <div class="cap-text">
              <strong>Follow-ups that don't slip</strong>
              <span>Reminders for every call, meeting and quote that is due.</span>
            </div>
          </li>
          <li>
            <span class="cap-icon violet"><i class="fas fa-chart-line"></i></span>
            <div class="cap-text">
              <strong>Forecasts you can trust</strong>
              <span>See expected revenue by stage, owner and month.</span>
            </div>
          </li>
        </ul>
      </section>

      <!-- AUTH -->
      <section class="auth-side">
        <div class="auth-card">
          <div class="card-inner">
            <h2 class="card-title">Welcome back</h2>
            <p class="card-subtitle">Sign in to your CRM workspace.</p>

            <!-- MODE TABS (hidden once OTP has been sent) -->
            <div class="mode-tabs" role="tablist" *ngIf="!isOtpSent">
              <button
                type="button"
                role="tab"
                class="mode-tab"
                [class.active]="!isMobileLogin"
                [attr.aria-selected]="!isMobileLogin"
                (click)="isMobileLogin && toggleLoginMode()"
              >
                <i class="fas fa-lock"></i> Password
              </button>
              <button
                type="button"
                role="tab"
                class="mode-tab"
                [class.active]="isMobileLogin"
                [attr.aria-selected]="isMobileLogin"
                (click)="!isMobileLogin && toggleLoginMode()"
              >
                <i class="fas fa-mobile-alt"></i> Mobile OTP
              </button>
            </div>

            <!-- PASSWORD LOGIN -->
            <form
              *ngIf="!isMobileLogin"
              [formGroup]="loginForm"
              (ngSubmit)="onLogin()"
            >
              <div class="form-group">
                <label class="form-label" for="crm-username">Username or email</label>
                <div class="input-wrap">
                  <i class="fas fa-user input-icon"></i>
                  <input
                    id="crm-username"
                    type="text"
                    class="form-control"
                    placeholder="Enter your username"
                    formControlName="username"
                    autocomplete="username"
                    [class.error]="
                      loginForm.get('username')?.invalid &&
                      loginForm.get('username')?.touched
                    "
                  />
                </div>
                <small
                  class="field-error"
                  *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched"
                >
                  <i class="fas fa-exclamation-circle"></i> Enter your username or email.
                </small>
              </div>

              <div class="form-group">
                <label class="form-label" for="crm-password">Password</label>
                <div class="password-wrap">
                  <i class="fas fa-key input-icon"></i>
                  <input
                    id="crm-password"
                    [type]="showPassword ? 'text' : 'password'"
                    class="form-control"
                    placeholder="Enter your password"
                    formControlName="password"
                    autocomplete="current-password"
                    [class.error]="
                      loginForm.get('password')?.invalid &&
                      loginForm.get('password')?.touched
                    "
                  />
                  <button
                    type="button"
                    class="pwd-toggle"
                    (click)="togglePassword()"
                    [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
                  >
                    <i
                      class="fas"
                      [class.fa-eye]="!showPassword"
                      [class.fa-eye-slash]="showPassword"
                    ></i>
                  </button>
                </div>
                <small
                  class="field-error"
                  *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
                >
                  <i class="fas fa-exclamation-circle"></i> Enter your password.
                </small>
              </div>

              <div class="form-meta">
                <label class="remember-label">
                  <input type="checkbox" /> Remember me
                </label>
              </div>

              <button
                type="submit"
                class="btn-primary"
                [disabled]="loginForm.invalid || loading"
                [class.loading]="loading"
              >
                <span class="btn-text">Sign in</span>
              </button>
            </form>

            <!-- MOBILE LOGIN -->
            <form
              *ngIf="isMobileLogin && !isOtpSent"
              [formGroup]="mobileForm"
              (ngSubmit)="sendOtp()"
            >
              <div class="form-group">
                <label class="form-label" for="crm-mobile">Mobile number</label>
                <div class="input-wrap">
                  <i class="fas fa-phone-alt input-icon"></i>
                  <input
                    id="crm-mobile"
                    type="tel"
                    class="form-control"
                    placeholder="10-digit mobile number"
                    formControlName="mobileNo"
                    maxlength="10"
                    inputmode="numeric"
                    autocomplete="tel-national"
                    [class.error]="
                      mobileForm.get('mobileNo')?.invalid &&
                      mobileForm.get('mobileNo')?.touched
                    "
                  />
                </div>
                <small
                  class="field-error"
                  *ngIf="mobileForm.get('mobileNo')?.invalid && mobileForm.get('mobileNo')?.touched"
                >
                  <i class="fas fa-exclamation-circle"></i> Enter a valid 10-digit mobile number.
                </small>
              </div>
              <button
                type="submit"
                class="btn-primary"
                [disabled]="mobileForm.invalid || loading"
                [class.loading]="loading"
              >
                <span class="btn-text">Send OTP</span>
              </button>
            </form>

            <!-- OTP VERIFICATION -->
            <div *ngIf="isOtpSent" class="otp-section">
              <p class="otp-note">{{ maskedMessage }}</p>
              <form [formGroup]="otpForm" (ngSubmit)="verifyOtp()">
                <div class="otp-boxes">
                  <input id="otp1" maxlength="1" inputmode="numeric" class="otp-input" formControlName="otp1" (input)="onOtpInput($event, 1)" aria-label="OTP digit 1" />
                  <input id="otp2" maxlength="1" inputmode="numeric" class="otp-input" formControlName="otp2" (input)="onOtpInput($event, 2)" aria-label="OTP digit 2" />
                  <input id="otp3" maxlength="1" inputmode="numeric" class="otp-input" formControlName="otp3" (input)="onOtpInput($event, 3)" aria-label="OTP digit 3" />
                  <input id="otp4" maxlength="1" inputmode="numeric" class="otp-input" formControlName="otp4" (input)="onOtpInput($event, 4)" aria-label="OTP digit 4" />
                  <input id="otp5" maxlength="1" inputmode="numeric" class="otp-input" formControlName="otp5" (input)="onOtpInput($event, 5)" aria-label="OTP digit 5" />
                  <input id="otp6" maxlength="1" inputmode="numeric" class="otp-input" formControlName="otp6" (input)="onOtpInput($event, 6)" aria-label="OTP digit 6" />
                </div>

                <div class="otp-meta">
                  <span class="timer" *ngIf="timerSeconds > 0">Code expires in {{ timerSeconds }}s</span>
                  <a
                    class="resend-link"
                    [class.disabled]="resendOtpDisabled"
                    (click)="!resendOtpDisabled && resendOtp()"
                    >Resend OTP</a
                  >
                </div>

                <button
                  type="submit"
                  class="btn-primary"
                  [disabled]="otpForm.invalid || loading"
                  [class.loading]="loading"
                >
                  <span class="btn-text">Verify and sign in</span>
                </button>

                <div class="change-wrap">
                  <a class="change-no" (click)="changeMobileNo()">Use a different number</a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </main>

    <!-- FOOTER -->
    <footer class="bottom-bar">
      <p>&copy; 2026 Nishwik CRM. All rights reserved.</p>
      <div class="bottom-links">
        <a routerLink="/policy/privacy">Privacy Policy</a>
        <a routerLink="/policy/terms">Terms &amp; Conditions</a>
        <a routerLink="/policy/cancellation">Cancellation Policy</a>
        <a routerLink="/policy/refund">Refund Policy</a>
        <a routerLink="/policy/contact">Contact us</a>
      </div>
    </footer>
  </div>
</div>
